export default __webpack_public_path__ + "44998965f9ff4af0c678007c3a61b8d3.png";